import { Dispatch, FC, SetStateAction } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch } from 'react-redux';
import { faRightFromBracket, faUser } from '@fortawesome/free-solid-svg-icons';
import { logout } from '../../../../reducer/authentication';
import {clearIDB} from '../../../../services/indexedDB';
import classes from './style.module.scss';

type IProfilePopUpProps = {
  setUserPopUpStatus: Dispatch<SetStateAction<boolean>>;
};

const ProfilePopUp: FC<IProfilePopUpProps> = ({ setUserPopUpStatus }) => {
  const dispatch = useDispatch();

  // * Function to logout the user * //
  const handleLogout = () => {
    dispatch(logout());
    setUserPopUpStatus(false);
    window.location.reload();
  };

  return (
    <div className={classes.container}>
      <div
        className={classes.wrapper}
        onClick={() => setUserPopUpStatus(false)}
      >
        <FontAwesomeIcon icon={faUser} />
        Profile
      </div>
      <div className={classes.wrapper} onClick={handleLogout}>
        <FontAwesomeIcon icon={faRightFromBracket} />
        Logout
      </div>
    </div>
  );
};

export default ProfilePopUp;
